module.exports = __webpack_public_path__ + "img/instagram.86aa35fe.png";